import { service } from './service'

import { config } from './config'

const { default_headers } = config

const request = (option: any) => {
const { url, method, params, data, headersType, responseType, timeout, signal } = option
 
  const requestConfig = {
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    signal,
    headers: {
      'Content-Type': headersType || default_headers
    }
  } as any

  if (typeof timeout === 'number') {
    requestConfig.timeout = timeout
  }

  return service(requestConfig)
}
export default {
  get: <T = any>(option: any) => {
    return request({ method: 'get', ...option }) as unknown as T
  },
  post: <T = any>(option: any) => {
    return request({ method: 'post', ...option }) as unknown as T
  },
  delete: <T = any>(option: any) => {
    return request({ method: 'delete', ...option }) as unknown as T
  },
  put: <T = any>(option: any) => {
    return request({ method: 'put', ...option }) as unknown as T
  }
}
